import { useContext } from 'react';
import cn from 'classnames';
import { MenuContext } from '../menuManager/menuManager';

import './menuBtn.scss';

const MenuButton = () => {
  const { setOpen, open } = useContext(MenuContext);

  return (
    <div className={cn('menu-button-wrap', { open })}>
      <button className="menu-button" onClick={() => setOpen(!open)}>
        <span />
      </button>
    </div>
  );
};

export default MenuButton;
